(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  document.documentElement.classList.add('js-enabled');

  // const header = $('[data-header]');
  // if (header) {
  //   const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
  //   updateHeader();
  //   window.addEventListener('scroll', updateHeader, { passive: true });
  // }

  const menuToggle = $('[data-menu-toggle]');
  const nav = $('[data-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      nav.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('menu-open', !isOpen);
    });
    $$('a', nav).forEach(link => link.addEventListener('click', () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }));
  }

  const revealItems = $$('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -35px 0px' });
    revealItems.forEach(item => {
      const delay = Number(item.getAttribute('data-reveal-delay') || 0);
      item.style.setProperty('--reveal-delay', `${Math.min(delay, 450)}ms`);
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach(item => item.classList.add('is-revealed'));
  }

  $$('[data-portfolio-filters]').forEach(filterWrap => {
    const buttons = $$('[data-filter]', filterWrap);
    const section = filterWrap.closest('section');
    const projects = $$('[data-project-category]', section);
    buttons.forEach(button => button.addEventListener('click', () => {
      const filter = button.dataset.filter;
      buttons.forEach(b => {
        b.classList.toggle('is-active', b === button);
        b.setAttribute('aria-pressed', String(b === button));
      });
      projects.forEach(project => {
        const show = filter === 'all' || project.dataset.projectCategory === filter;
        project.hidden = !show;
        if (show) project.classList.add('is-revealed');
      });
    }));
  });

  $$('[data-pricing-tabs]').forEach(tabs => {
    const buttons = $$('[data-pricing-tab]', tabs);
    const section = tabs.closest('section');
    const plans = $$('[data-price-category]', section);
    const applyFilter = (button) => {
      const category = button.dataset.pricingTab;
      buttons.forEach(b => {
        b.classList.toggle('is-active', b === button);
        b.setAttribute('aria-selected', String(b === button));
      });
      plans.forEach(plan => { plan.hidden = plan.dataset.priceCategory !== category; });
      const track = $('[data-pricing-track]', section);
      if (track) track.scrollLeft = 0;
      const carousel = $('[data-pricing-carousel]', section);
      if (carousel && carousel._updatePricingCarousel) carousel._updatePricingCarousel();
    };
    if (buttons.length) {
      buttons.forEach(button => button.addEventListener('click', () => applyFilter(button)));
      applyFilter(buttons[0]);
    }
  });

  // Remember plan variant IDs encountered across the storefront so a plan selected on
  // another service page can also be replaced rather than duplicated in the cart.
  const visiblePlanVariantIds = new Set();
  $$('[data-pricing-section] [data-plan-variant] option').forEach(option => visiblePlanVariantIds.add(String(option.value)));
  $$('[data-pricing-section] [data-plan-variant-id]').forEach(field => visiblePlanVariantIds.add(String(field.value)));
  if (visiblePlanVariantIds.size) {
    try {
      const saved = JSON.parse(localStorage.getItem('The Web Tech_pricing_variant_ids') || '[]');
      localStorage.setItem('The Web Tech_pricing_variant_ids', JSON.stringify([...new Set([...saved.map(String), ...visiblePlanVariantIds])].slice(-250)));
    } catch (_) {}
  }

  // Pricing cards: actual Shopify variants control the displayed price and availability.
  $$('[data-pricing-section] .pricing-card').forEach(card => {
    const variantSelect = $('[data-plan-variant]', card);
    const price = $('[data-plan-price]', card);
    const submit = $('[data-plan-submit]', card);
    const form = $('.plan-checkout-form', card);
    const updateVariant = () => {
      if (!variantSelect) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      if (price && option.dataset.money) price.textContent = option.dataset.money;
      if (submit) {
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        const label = submit.dataset.defaultLabel || submit.textContent.replace('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" > <path d="M7 17 17 7" /> <path d="M7 7h10v10" /> </svg>', '').trim();
        if (!submit.dataset.defaultLabel) submit.dataset.defaultLabel = label;
        submit.firstChild.textContent = available ? submit.dataset.defaultLabel + ' ' : 'Sold out ';
      }
    };
    if (variantSelect) {
      variantSelect.addEventListener('change', updateVariant);
      updateVariant();
    }
    if (form) {
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const selected = variantSelect && variantSelect.options[variantSelect.selectedIndex];
        const idField = form.elements.namedItem('id');
        const variantId = selected ? selected.value : (idField ? idField.value : '');
        const message = $('[data-plan-error]', card);
        const button = $('[data-plan-submit]', form);
        const originalButtonText = button ? button.textContent : '';
        const setError = text => { if (message) message.textContent = text; };
        setError('');
        if (!variantId || (selected && selected.dataset.available !== 'true')) {
          setError('This plan is unavailable. Please choose another option or contact us.');
          return;
        }
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Preparing checkout…'; }
        card.classList.add('is-selected');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const request = async (path, options = {}) => {
          const response = await fetch(root + path, { credentials: 'same-origin', ...options, headers: { 'Accept': 'application/json', ...(options.body ? {'Content-Type':'application/json'} : {}), ...(options.headers || {}) } });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.description || payload.message || 'Shopify could not prepare checkout.');
          return payload;
        };
        try {
          // Only replace The Web Tech pricing-plan line items; keep unrelated products in the cart.
          // This prevents a second selection after returning from checkout from duplicating the plan.
          const planIds = new Set();
          try { const savedIds = JSON.parse(localStorage.getItem('The Web Tech_pricing_variant_ids') || '[]'); savedIds.forEach(id => planIds.add(String(id))); const previousPlanId = localStorage.getItem('The Web Tech_last_pricing_variant'); if (previousPlanId) planIds.add(String(previousPlanId)); } catch (_) {}
          $$('[data-pricing-section] [data-plan-variant] option').forEach(option => planIds.add(String(option.value)));
          $$('[data-pricing-section] [data-plan-variant-id]').forEach(field => planIds.add(String(field.value)));
          const cart = await request('cart.js');
          const updates = {};
          (cart.items || []).forEach(item => {
            if (planIds.has(String(item.variant_id))) updates[item.key] = 0;
          });
          if (Object.keys(updates).length) await request('cart/update.js', { method: 'POST', body: JSON.stringify({ updates }) });
          await request('cart/add.js', { method: 'POST', body: JSON.stringify({ id: Number(variantId), quantity: 1 }) });
          // Persist a small diagnostic marker only; cart cleanup is server-side on every selection.
          try { localStorage.setItem('The Web Tech_last_pricing_variant', String(variantId)); } catch (_) {}
          window.location.assign(root + 'checkout');
        } catch (error) {
          setError(error.message || 'We could not prepare checkout. Please try again.');
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = originalButtonText; }
        }
      });
    }
    card.addEventListener('click', event => {
      if (event.target.closest('a,button,select,label,form')) return;
      $$('.pricing-card.is-selected', card.parentElement).forEach(other => other.classList.remove('is-selected'));
      card.classList.add('is-selected');
    });
  });


  // Accessible pricing carousel: swipe, trackpad, arrows, and 4–5 plans per category.
  $$('[data-pricing-carousel]').forEach(carousel => {
    const track = $('[data-pricing-track]', carousel);
    const prev = $('[data-pricing-prev]', carousel);
    const next = $('[data-pricing-next]', carousel);
    const status = $('[data-pricing-status]', carousel);
    if (!track || !prev || !next || !status) return;
    const visibleCards = () => $$('[data-price-category]', track).filter(card => !card.hidden);
    const stepSize = () => {
      const card = visibleCards()[0];
      if (!card) return track.clientWidth || 1;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const update = () => {
      const cards = visibleCards();
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      prev.disabled = track.scrollLeft <= 3;
      next.disabled = track.scrollLeft >= maxScroll - 3 || maxScroll <= 3;
      const step = stepSize();
      const index = Math.min(Math.max(1, cards.length), Math.floor((track.scrollLeft + step * .35) / Math.max(1, step)) + 1);
      status.textContent = `${index} / ${Math.max(1, cards.length)}`;
      carousel.classList.toggle('has-overflow', maxScroll > 3);
    };
    prev.addEventListener('click', () => track.scrollBy({left:-stepSize(),behavior:'smooth'}));
    next.addEventListener('click', () => track.scrollBy({left:stepSize(),behavior:'smooth'}));
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    carousel._updatePricingCarousel = () => requestAnimationFrame(update);
    update();
  });

  const backTop = $('[data-back-top]');
  if (backTop) backTop.addEventListener('click', event => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  $$('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', event => {
      const target = $(anchor.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();